<template>
	<div>
		<div style="margin-bottom:15px">
			<el-radio-group v-model="status" size="small" @change="getData(1)">
				<el-radio-button :label="1">待开票</el-radio-button>
				<el-radio-button :label="2">已开票</el-radio-button>
			</el-radio-group>
		</div>
		<el-table
			:data="tableData"
			v-loading="tableLoading"
			element-loading-text="正在查询..."
			border
		>
			<!-- <el-table-column type="selection" width="55"></el-table-column> -->
			<el-table-column
				label="消费单号"
				prop="ordersn"
				align="center"
			></el-table-column>
			<el-table-column
				label="会员卡号"
				prop="card.card_num"
				align="center"
			></el-table-column>
			<el-table-column label="手机号码" prop="user.mobile" align="center">
			</el-table-column>
			<el-table-column
				label="油品"
				prop="show_goodsname"
				align="center"
			></el-table-column>
			<el-table-column label="升数" prop="num" align="center"></el-table-column>
			<el-table-column label="应收金额" prop="money"></el-table-column>
			<el-table-column label="实付金额" prop="amount" align="center">
			</el-table-column>
			<el-table-column
				label="手续费"
				prop="fee"
				align="center"
			></el-table-column>
			<el-table-column label="入账金额" align="center">
				<template slot-scope="scope">
					<span>{{
						(Number(scope.row.amount) - Number(scope.row.fee)).toFixed(2)
					}}</span>
				</template>
			</el-table-column>
			<el-table-column label="支付方式" align="center">
				<template slot-scope="scope">
					<div>{{ scope.row.show_payway }}</div>
				</template>
			</el-table-column>
			<el-table-column
				label="下单时间"
				width="99px"
				prop="create_time"
				align="center"
			></el-table-column>
			<el-table-column
				label="支付时间"
				width="99px"
				prop="show_payTime"
				align="center"
			></el-table-column>
			<el-table-column
				label="操作员"
				prop="show_empname"
				align="center"
			></el-table-column>
			<el-table-column
				label="来源"
				prop="show_from"
				align="center"
			></el-table-column>
			<el-table-column label="操作" width="120px" align="center" fixed="right">
				<template slot-scope="scope">
					<el-button type="text" @click="receiptInfo(scope.row.id)"
						>开票信息</el-button
					>
					<el-button type="text" @click="submitReceipt(scope.row.id)"
						>确认</el-button
					>
				</template>
			</el-table-column>
		</el-table>
		<div style="margin-top:20px">
			<el-pagination
				layout="prev, pager, next, total"
				:current-page="page"
				:total="total"
				:page-size="10"
				background
				@current-change="getData"
			>
			</el-pagination>
		</div>
		<el-dialog
			:visible.sync="showReceiptInfo"
			title="开票信息"
			width="600px"
			append-to-body
		>
			<div class="car_msg_box">
				<div class="car_msg_item">
					发票类型：{{ receiptData.type == 1 ? "个人" : "企业" }}
				</div>
				<div class="car_msg_item">发票抬头：{{ receiptData.tax_name }}</div>
				<div class="car_msg_item">开票金额：{{ receiptData.money }}</div>
				<div class="car_msg_item">
					开票状态：{{ receiptData.status == 1 ? "已开票" : "未开票" }}
				</div>
				<div class="car_msg_item">税号：{{ receiptData.tax_id }}</div>
				<div class="car_msg_item">邮箱地址：{{ receiptData.email }}</div>
				<div class="car_msg_item">开户银行：{{ receiptData.bank }}</div>
				<div class="car_msg_item">银行账号：{{ receiptData.bank_account }}</div>
				<div class="car_msg_item">电话号码：{{ receiptData.address }}</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import {
	oilsOrder,
	vipOrderListNow,
	orderReceiptMsg,
	confirmReceipt,
	last_shift_lists,
} from "@/api/vip";
export default {
	computed: {
		...mapGetters(["token", "app_id"]),
	},
	props: {
		allOrder: {
			type: Number,
			default: 0,
		},
	},
	data() {
		return {
			page: 1,
			total: 0,
			status: 1, // 1.待开票 2.已开票
			tableData: [],
			tableLoading: false,
			receiptData: {},
			showReceiptInfo: false,
			paywayList: [
				{ id: "wxpay", name: "微信支付" },
				{ id: "balance", name: "余额支付" },
				{ id: "cash", name: "现金支付" },
				{ id: "single_wxpay", name: "微信免签" },
				{ id: "single_alipay", name: "支付宝免签" },
				{ id: "unionpay", name: "银联支付" },
				{ id: "card_balance", name: "加油卡支付" },
				{ id: "allinpay", name: "通联支付" },
				{ id: "family_balance", name: "亲属卡支付" },
				{ id: "team_balance", name: "车队卡支付" },
			],
		};
	},
	mounted() {
		this.getData();
	},
	methods: {
		getData(i) {
			this.tableLoading = true;
			if (i) {
				this.page = i;
			}
			var data = {
				token: this.token,
				app_id: this.app_id,
				receipt: this.status,
				page: this.page,
			};
			if (this.allOrder == 0) {
				oilsOrder(data).then((res) => {
					this.tableLoading = false;
					if (res.code == 200) {
            this.tableData = res.data;
						this.tableData.forEach((item) => {
							item.show_goodsname = item.goods
								? item.cate.name + " " + item.goods.name + item.type.name
								: "";
							item.show_from =
								item.source == "wx"
									? "微信"
									: item.source == "h5"
									? "支付宝"
									: item.source == "wxapp"
									? "微信小程序"
									: item.source == "aliapp"
									? "支付宝小程序"
									: item.source == "pos"
									? "终端机"
									: item.source == "pc"
									? "后台"
									: "";
							item.show_payTime = item.payment_time
								? this.mydateFormat(item.payment_time)
								: "";
							item.show_empname = item.emp == null ? "买单" : item.emp.name;
							item.show_payway = this.paywayList.find(
								(x) => x.id == item.payment_code
							).name;
						});
						this.total = res.total;
					} else {
						this.$message(res.msg);
						this.tableData = [];
						this.total = 0;
					}
				});
			} else if (this.allOrder == 3) {
				last_shift_lists(data).then((res) => {
					this.tableLoading = false;
					if (res.code == 200) {
						this.tableData = res.data;
						if (this.tableData) {
							this.tableData.forEach((item) => {
								item.show_goodsname = item.goods
									? item.cate.name + " " + item.goods.name + item.type.name
									: "";
								item.show_from =
									item.source == "wx"
										? "微信"
										: item.source == "h5"
										? "支付宝"
										: item.source == "wxapp"
										? "微信小程序"
										: item.source == "aliapp"
										? "支付宝小程序"
										: item.source == "pos"
										? "终端机"
										: item.source == "pc"
										? "后台"
										: "";
								item.show_payTime = item.payment_time
									? this.mydateFormat(item.payment_time)
									: "";
								item.show_empname = item.emp == null ? "买单" : item.emp.name;
								item.show_payway = this.paywayList.find(
									(x) => x.id == item.payment_code
								).name;
							});
						}

						this.total = res.total;
					} else {
						this.$message(res.msg);
						this.tableData = [];
						this.total = 0;
					}
				});
			} else {
				vipOrderListNow(data).then((res) => {
					this.tableLoading = false;
					if (res.code == 200) {
						this.tableData = res.data;
						this.tableData.forEach((item) => {
							item.show_goodsname = item.goods
								? item.cate.name + " " + item.goods.name + item.type.name
								: "";
							item.show_from =
								item.source == "wx"
									? "微信"
									: item.source == "h5"
									? "支付宝"
									: item.source == "wxapp"
									? "微信小程序"
									: item.source == "aliapp"
									? "支付宝小程序"
									: item.source == "pos"
									? "终端机"
									: item.source == "pc"
									? "后台"
									: "";
							item.show_payTime = item.payment_time
								? this.mydateFormat(item.payment_time)
								: "";
							item.show_empname = item.emp == null ? "买单" : item.emp.name;
							item.show_payway = this.paywayList.find(
								(x) => x.id == item.payment_code
							).name;
						});
						this.total = res.total;
					} else {
						this.$message(res.msg);
						this.tableData = [];
						this.total = 0;
					}
				});
			}
		},
		receiptInfo(id) {
			var data = {
				token: this.token,
				app_id: this.app_id,
				order_id: id,
			};
			orderReceiptMsg(data).then((res) => {
				if (res.code == 200) {
					this.receiptData = res.data;
					this.showReceiptInfo = true;
				} else {
					this.$message(res.msg);
				}
			});
		},
		submitReceipt(id) {
			this.$confirm("确认开票？", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
			})
				.then(() => {
					var data = {
						token: this.token,
						app_id: this.app_id,
						id: id,
					};
					confirmReceipt(data).then((res) => {
						if (res.code == 200) {
							this.$message({
								type: "success",
								message: "提交成功！",
							});
							this.$emit("refresh");
						} else {
							this.$message({
								type: "error",
								message: res.msg,
							});
						}
					});
				})
				.catch();
		},
	},
};
</script>

<style lang="scss" scoped>
.car_msg_box {
	display: flex;
	flex-wrap: wrap;
	.car_msg_item {
		width: 50%;
		line-height: 40px;
	}
}
</style>
